export const FullNameFormatter = ({ name, surname }) => {
  return `${name} ${surname}`;
};
